import { render, staticRenderFns } from "./CreateDialog.vue?vue&type=template&id=67db7316&scoped=true&"
import script from "@/views/Users/Student/CreateDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/CreateDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/create-dialog.scss?vue&type=style&index=0&id=67db7316&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67db7316",
  null
  
)

export default component.exports